import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import VisionBoardDashboard from './VisionBoardDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyVisionBoardDashboard } from './companyVisionBoardApi';

/** Company Vision Board → Dashboard, scoped to this company. */
const CVisionBoardDashboard = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyVisionBoardDashboard(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vision Board | Shoorah</title>
      </Helmet>
      <VisionBoardDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CVisionBoardDashboard;
